export default "__VITE_ASSET__d5df0b60__"